export default "__VITE_ASSET__BdpKrFeq__"